export default "/images/custom_development/web_3_design_and_development__top_image.png";